var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"itemAcessoRestrito"}},[_c('ul',_vm._l((_vm.items),function(item){return _c('li',[_c('a',{attrs:{"href":item.link}},[_c('div',{staticClass:"img"},[_c('img',{staticClass:"image",attrs:{"src":item.image}})]),_c('h4',[_vm._v(_vm._s(item.title))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }